import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { log } from 'console';
import { SettlementServiceService } from '../../../services/raintree/Transmission/settlement-service.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../../common-component/loader/loader.component';


@Component({
  selector: 'app-upload-document-dialog',
  standalone: true,
  imports: [MatIcon, FormsModule, CommonModule, LoaderComponent],
  templateUrl: './upload-document-dialog.component.html',
  styleUrl: './upload-document-dialog.component.scss'
})
export class UploadDocumentDialogComponent implements OnInit {

  // file: File[] = [];
  // imagePreview: string[] = [];
  file!: File;
  imagePreview!: string;
  comments!: string;
  isLoading: boolean = false;
  status: string = 'Slip-found';
  sendingBaackData: any

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<UploadDocumentDialogComponent>,
    private settlemetdialog: SettlementServiceService,
    private toaster: ToastrService
  ) { }
  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close()
  }
  // this is for single file upload
  uploadDoc() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = (event: any) => {
      const selectedFile = (event.target as HTMLInputElement).files?.[0];
      if (!selectedFile) return;

      this.file = selectedFile;

      // Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(this.file);
    };

    input.click();
  }

  submitdocx() {
    const formData = new FormData()
    formData.append('bankTransUUID', this.data.data.id,)
    formData.append('comment', this.comments)

    // this.file.forEach(file => {
    // formData.append('docs', file, file.name);
    formData.append('docs', this.file)
    // });
    formData.append('status', this.status)
    this.isLoading = true
    this.settlemetdialog.uploadDocx(formData).subscribe({
      next: (result) => {
        this.isLoading = false
        console.log(result);
        this.toaster.success("Successfully Uploaded")
      }, error: (error: any) => {
        this.toaster.error(error);
      },
    })
    this.dialogRef.close(this.data)
  }

  // removeImage(index: number) {
  //   this.imagePreview.splice(index, 1);
  //   this.file.splice(index, 1);
  // }

}